<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

        <b-button tag="router-link" :to="{name: 'PromoCreate'}">Создать</b-button>

        <hr/>

        <b-table :data="promos"

                 hoverable
                 bordered

                 narrowed
                 paginated
        >
            <b-table-column field="name" label="Название" centered>
                <template v-slot="props">
                    {{ props.row.title }}
                </template>
            </b-table-column>

            <b-table-column field="description" label="Описание" centered>
                <template v-slot="props">
                    {{ props.row.description }}
                </template>
            </b-table-column>

            <b-table-column field="active" label="Активность" centered>
                <template v-slot="props">
                    <b-tag v-if="props.row.is_active" type="is-success">Да</b-tag>
                    <b-tag v-else type="is-danger">Нет</b-tag>
                </template>
            </b-table-column>

            <b-table-column field="price" label="Действие" centered>
                <template v-slot="props">
                    {{ actionTitle(props.row.action) }}

                    <template v-if="props.row.action === 1">
                        ({{ selectedDish(props.row.info.id) }})
                    </template>
                    <template v-if="props.row.action === 2">
                        ({{ selectedCombo(props.row.info.id) }})
                    </template>

                    <template v-if="props.row.action === 3">
                        ({{ props.row.info.url }})
                    </template>

                </template>
            </b-table-column>

            <b-table-column field="image" label="Изображение" width="200" centered>
                <template v-slot="props">
                    <img :src="props.row.image" alt/>
                </template>
            </b-table-column>

            <b-table-column field="edit" label="Действия" centered>
                <template v-slot="props">
                    <div class="buttons">
                        <b-button type="is-primary" icon-right="pencil-outline"
                                  tag="router-link" :to="{ name: 'PromoEdit', params: {id: props.row.id} }"

                                  :disabled="loading"
                        />

                        <b-button type="is-primary" icon-right="arrow-down-bold"
                                  @click="downOrder(props.row.id)" v-if="props.index + 1 !== promos.length"

                                  :disabled="loading"
                        />

                        <b-button type="is-primary" icon-right="arrow-up-bold"
                                  @click="upOrder(props.row.id)" v-if="props.index !== 0"

                                  :disabled="loading"
                        />

                        <b-button type="is-primary" icon-right="delete"
                                  @click="remove(props.row.id)"

                                  :disabled="loading"
                        />
                    </div>
                </template>
            </b-table-column>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="emoticon-frown-outline"
                                    size="is-large"
                            />
                        </p>
                        <p>Промо отсутствуют</p>
                    </div>
                </section>
            </template>
        </b-table>
    </section>
</template>

<script>
import promoRepository from "../../repository/promoRepository";
import comboRepository from "../../repository/comboRepository";
import dishRepository from "../../repository/dishRepository";

export default {
    data() {
        return {
            loading: false,
            promos: [],
            dishes: [],
            combos: [],
        }
    },
    methods: {
        fetchData() {
            this.loading = true;

            return promoRepository.list()
                .then(({data}) => {
                    this.promos = data
                })
                .then(() => this.$buefy.toast.open('Акции загружены'))
                .catch(() => this.$buefy.toast.open('Ошибка при загрузке акций'))
                .finally(() => {
                    this.loading = false
                })
        },
        upOrder(promoId) {
            this.loading = true;

            return promoRepository.upOrder(promoId)
                .then(() => this.fetchData())
                .then(() => this.$buefy.toast.open('Место в порядке акции увеличено'))
                .catch(() => this.$buefy.toast.open('Ошибка при смене порядка акции'))
                .finally(() => {
                    this.loading = false
                })
        },
        downOrder(promoId) {
            this.loading = true;

            promoRepository.downOrder(promoId)
                .then(() => this.fetchData())
                .then(() => this.$buefy.toast.open('Место в порядке акции уменьшено'))
                .catch(() => this.$buefy.toast.open('Ошибка при смене порядка акции'))
                .finally(() => {
                    this.loading = false
                })
        },
        remove(promoId) {
            this.loading = true;

            promoRepository.delete(promoId)
                .then(() => this.fetchData())
                .then(() => this.$buefy.toast.open('Акция удалена'))
                .catch(() => this.$buefy.toast.open('Ошибка при удалении акции'))
                .finally(() => {
                    this.loading = false
                })
        },
        selectedDish(id) {
            if (this.dishes.length > 0)
                return this.dishes.find(dish => dish.id === +id).name;

            return null;
        },
        selectedCombo(id) {
            if (this.combos.length > 0)
                return this.combos.find(combo => combo.id === +id).name;

            return null;
        },
        actionTitle(action) {
            const title = {
                1: "Блюдо",
                2: "Комбо",
                3: "Ссылка",
                4: "Ничего"
            };

            return title[action];
        },
        fetchCombos() {
            comboRepository.list()
                .then(({data}) => this.combos = data)
        },
        fetchDishes() {
            dishRepository.list()
                .then(({data}) => this.dishes = data)
        }
    },
    mounted() {
        this.fetchCombos()
        this.fetchDishes()
        this.fetchData()
    }
}
</script>

<style scoped>

</style>
